<template>
  <div :style="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.sm ? 'margin: 0 24px' : null">
    <div v-if="!event || ticketsListLoading">
      <spinner />
    </div>
    <v-layout v-else justify-flex-end>
      <link v-if="customStyles.stylesheet" rel="stylesheet" :href="customStyles.stylesheet" />
      <v-flex v-if="event.applicationsOpen" xs12>
        <application-header />
        <v-layout
          v-if="!showMessage"
          wrap
          class="register-layout"
          :style="
            event.extraModules.ticketing ? 'justify-content:flex-end' : 'justify-content:center'
          "
        >
          <v-flex xs12 sm7 md6 lg6 shrink>
            <v-responsive
              v-if="event.cover && activeStep === 1 && event.extraModules.ticketing"
              class="event-cover"
              :style="{ backgroundImage: 'url(' + event.cover + ')' }"
            />
            <v-flex v-else-if="activeStep === 1">
              <div v-if="event.cover" class="event-cover">
                <img :src="event.cover" alt="cover image" />
              </div>
              <card-header :event="event" />
            </v-flex>
            <tickets-list
              v-if="activeStep === 1 && event.extraModules.ticketing"
              :event="event"
              :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
              :initial-values="shoppingCart"
              @back="
                form.ticket = $event
                activeStep = 2
              "
              @next="
                form.ticket = $event
                activeStep = 2
              "
              @selectedTickets="selectedTickets"
              @applyPromo="applyPromoCode"
              @startLoading="ticketsListLoading = true"
              @finishLoading="ticketsListLoading = false"
            />
            <attendee-data
              v-else-if="activeStep === 1"
              :event="event"
              :schema="schema"
              :styles="customStyles.attendeeForm"
              :category="category"
              :initial-values="form.attendee"
              @back="
                form.attendee = $event
                goBack()
              "
              @next="
                form.attendee = $event
                activeStep = event.extraModules.workshops ? 3 : submitStepper()
              "
              @submit="
                form.attendee = $event
                submitStepper()
              "
            />
            <checkout
              v-if="activeStep === 2"
              :event="event"
              :schema="schema"
              :category="category"
              :styles="customStyles.attendeeForm"
              :initial-values="form.attendee"
              :selected-tickets="shoppingCart"
              @back="
                form.attendee = $event
                activeStep = 1
              "
              @next="
                form.attendee = $event
                activeStep = event.extraModules.workshops ? 3 : purchaseTicket()
              "
            />
            <workshops-list
              v-if="activeStep === 3"
              :event="event"
              :selected="form.workshops"
              :styles="customStyles.workshopsForm"
              :workshops="event.workshops"
              @back="
                form.workshops = $event
                activeStep = event.extraModules.ticketing ? 2 : 1
              "
              @submit="
                form.workshops = $event
                event.extraModules.ticketing ? purchaseTicket() : submitStepper()
              "
            />
          </v-flex>
          <v-flex
            v-if="event.extraModules.ticketing"
            xs12
            sm4
            md4
            lg4
            shrink
            :class="activeStep === 1 ? 'cover-header-style' : 'cover-header-noTicket'"
          >
            <card-header-cover
              v-if="(event.cover && event.extraModules.ticketing) || activeStep !== 1"
              :style="{ backgroundColor: getThemeStyle(event.coverImagePrimaryColor, 0.05) }"
              :event="event"
              :active-step="activeStep"
            />
            <ticket-price-list
              v-if="event.extraModules.ticketing"
              ref="ticketPriceList"
              :selected-tickets="shoppingCart"
              :step="activeStep"
              :cover="event.cover"
              :promo-code="promoCode"
            />
            <credit-card-company-logos v-if="event.extraModules.ticketing" />
          </v-flex>
        </v-layout>
        <v-layout v-else justify-center>
          <v-flex shrink class="registration-success-page">
            <img
              class="info-image"
              alt="mail_success"
              src="../../../public/assets/mail_success.svg"
            />
            <div class="my-page-title">
              <span v-if="customStyles.base && customStyles.base.submitNote">{{
                customStyles.base.submitNote
              }}</span>
              <span v-else>Zahvaljujemo se na registraciji!</span>
            </div>
            <div v-if="customStyles.base && customStyles.base.submitInfo" class="description">
              {{ customStyles.base.submitInfo }}
            </div>
            <div v-else class="description">
              Podaci koje ste naveli poslani su organizatorima. Samo pričekaj sekundu i poslat ćemo
              vam e-mail.
            </div>
            <div class="text-center mt-12">
              <main-button
                :text="(customStyles.base && customStyles.base.addAnother) || $t('addAttendee')"
                @click="addAnother"
              />
            </div>
          </v-flex>
        </v-layout>
        <simple-snackbar :open.sync="showError" color="primary" :message-prop="snackbarMessage" />
      </v-flex>
      <v-flex v-else xs12>
        <v-layout wrap justify-center style="height: 100%">
          <v-flex class="card-header-container" shrink xs12 sm10 md8>
            <application-header />
          </v-flex>
          <v-flex shrink class="registration-success-page">
            <img class="info-image" src="../../../public/assets/sad_cloud.svg" alt="sad_cloud" />
            <h1 v-if="customStyles.base && customStyles.base.eventClosed" class="my-page-title">
              {{ customStyles.base.eventClosed }}
            </h1>
            <h1 v-else class="my-page-title">Prijave za ovaj događaj su zatvorene.</h1>
          </v-flex>
        </v-layout>
      </v-flex>
      <simple-snackbar
        :open.sync="snackbarOpen"
        message-prop="Uspješno ste registrirali posjetitelja."
        color="primary"
      />
    </v-layout>
    <div class="mt-220">
      <application-footer />
    </div>
  </div>
</template>

<script>
import { createPendingAccreditation, createPurchaseAccreditationsPublic } from '../../http'
import CardHeader from './../shared/card-header.vue'
import Spinner from './../shared/spinner'
import AttendeeData from './register-stepper/attendee-data.vue'
import WorkshopsList from './register-stepper/workshops-list.vue'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import ApplicationFooter from '../shared/application-footer.vue'
import { submitGuard, createAttendeeSchema, createPurchaseSubmitFormWSPay } from './../../utils'
import ApplicationHeader from '../shared/application-header.vue'
import CreditCardCompanyLogos from './register-stepper/credit-card-company-logos.vue'

import { GET_ACCREDITATION_INVITE } from '../../graphql/eventCategoryRequest.graphql'
import { requiredIf } from 'vuelidate/lib/validators'
import TicketsList from '@/components/accreditations/register-stepper/tickets-list'
import CardHeaderCover from '@/components/shared/card-header-cover'
import TicketPriceList from '@/components/accreditations/register-stepper/ticket-price-list'
import Checkout from '@/components/accreditations/register-stepper/checkout'

export default {
  name: 'invite-accreditation',
  components: {
    ApplicationHeader,
    Spinner,
    WorkshopsList,
    CardHeader,
    AttendeeData,
    SimpleSnackbar,
    ApplicationFooter,
    TicketsList,
    CardHeaderCover,
    TicketPriceList,
    Checkout,
    CreditCardCompanyLogos,
  },
  props: {
    inviteToken: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    showMessage: false,
    activeStep: 1,
    event: null,
    category: {},
    form: {
      attendee: {},
      workshops: [],
    },
    showError: false,
    errorMessage: '',
    customStyles: {},
    schema: {},
    snackbarOpen: false,
    snackbarMessage: '',
    initialAttendee: {},
    loading: true,
    coverColor: {},
    backgroundCoverColor: {},
    shoppingCart: [],
    promoCode: {},
    eventSlug: '',
    ticketsListLoading: false,
  }),
  computed: {
    referralName() {
      return this.$route.query.ref
    },
  },
  validations() {
    return {
      form: {
        category: {
          required: requiredIf(() => this.event.extraModules.categoriesAndZones && !this.category),
        },
        ...this.schema.validationSchema,
      },
    }
  },
  methods: {
    async createAttendee({ attendee, workshops }) {
      let { category, zones, ...fields } = attendee
      if (this.category) {
        zones = this.category.zones
      }
      const categoryId = category || (this.category && this.category.id)
      const variables = {
        eventId: this.event.id,
        attendee: { fields, categoryId, zones },
        workshopIds: workshops,
        token: this.inviteToken,
        referralName: this.referralName,
      }
      const response = await createPendingAccreditation(variables)
      if (response && !response.errors) {
        this.showMessage = true
      } else {
        this.errorMessage = response.errors[0].message
        this.form.workshops = []
        this.showError = true
      }
    },
    async createAttendees({ attendee, workshops }, skipReset = false) {
      let fields,
        AttendeeList = []
      let { tickets, ...buyer } = attendee
      let buyerInfo = { fields: buyer }
      for (let attendeeTicket of attendee.tickets) {
        fields = attendeeTicket
        AttendeeList.push({ fields })
      }
      const variables = {
        eventId: this.event.id,
        attendees: AttendeeList,
        workshopIds: workshops,
        referralName: this.referralName,
        promoCode: this.promoCode.id,
        buyer: buyerInfo,
        price: this.totalPrice(),
      }
      const response = await createPurchaseAccreditationsPublic(variables)

      if (response && !response.errors) {
        return response
      } else {
        this.showError = true
        this.snackbarMessage = response.errors[0].message

        return
      }
    },
    async submitStepper() {
      await this.createAttendee(this.form)
    },
    async submitForm() {
      await submitGuard(this, async () => {
        await this.createAttendee({ attendee: this.form })
        this.showMessage = true
        this.$v.$reset()
      })
    },
    async purchaseTicket() {
      const {
        data: { createPurchaseAccreditationsPublic: attendees },
      } = await this.createAttendees(this.form)
      const form = await createPurchaseSubmitFormWSPay(
        this.form,
        this.totalPrice(),
        attendees,
        this.shoppingCart,
        this.event.id,
      )
      document.body.appendChild(form)
      form.submit()
    },
    selectedTickets(tickets) {
      this.shoppingCart = tickets
    },
    addAnother() {
      this.form = {}
      this.activeStep = 1
      this.showMessage = false
    },
    applyPromoCode(promoCodeInput) {
      this.promoCode = promoCodeInput
    },
    totalPrice() {
      return this.$refs.ticketPriceList.getTotalPrice()
    },
    goBack() {
      this.$router.push({
        name: 'event-public',
        params: { slug: this.event.slug },
      })
    },
  },
  apollo: {
    getAccreditationInvite: {
      query: GET_ACCREDITATION_INVITE,
      variables() {
        return {
          token: this.inviteToken,
        }
      },
      manual: true,
      result({ data, loading }) {
        if (!loading && data) {
          const { event, category } = data.getAccreditationInvite
          this.customStyles = event.eventUtils ? event.eventUtils.inviteFormStyles : {}
          this.event = event
          this.eventSlug = event.slug
          this.schema = createAttendeeSchema(event.attendeeFields)
          this.category = category
        }
      },
    },
  },
}
</script>

<style scoped>
.event-cover {
  background-size: cover;
  border-radius: 8px 8px 0 0;
  font-size: 0;
  display: flex;
  height: 220px;
  max-width: 602px;
}

@supports not (aspect-ratio: 16/9) {
  .event-cover {
    position: relative;
    height: 0;
    padding-top: 33.33333%;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.event-cover img {
  aspect-ratio: 16/9;
  object-fit: fill;
  width: 100%;
  border-radius: 8px 8px 0 0;
}

.info-image {
  width: 100%;
}

.registration-success-page {
  /* margin-left: 12px; */
}
</style>
